import React, { useState, useEffect } from "react";
import Helmet from "react-helmet";
import { useDispatch, useSelector } from "react-redux";
import FadeLoader from "react-spinners/FadeLoader";
import { SUPPORT } from "common/viewContent";
import * as Path from "routes/Path/index";
import { toast } from "react-toastify";
import Table from "components/Table";
import Columns from "./Columns";
import { Link, useNavigate } from "react-router-dom";
import { getSupportListData, SupportEdit } from "store/actions";
import EditSupport from "components/Modals/EditSupport";
const List = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [columns, setcolumns] = useState([{ dataField: "", text: "" }]);
  const { USER, loading, totalCount } = useSelector((state) => state.Doctor);
  const [doctor, setDoctor] = useState();
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(20);
  const [datasets, setDatasets] = useState();
  const [search_text, setSearch_text] = useState();
  const [editModalShow, setEditModalShow] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const [filter, setFilter] = useState({
    pageNo: currentPage,
    limit: pageSize,
    search_text: "",
  });
  const [formData, setFormData] = useState({
    status: "",
  });

  const fetchData = async (filter) => {
    setIsLoading(true);
    const payload = {
      ...filter,
      page: filter?.pageNo,
      record_count: filter?.limit,
    };
    try {
      const callback = (err, res) => {
        if (err) {
          toast.error(err);
          setIsLoading(false);
          setDoctor();
        } else {
          setDoctor(res);
          setIsLoading(false);
        }
      };
      dispatch(
        getSupportListData({
          data: payload,
          callback,
        })
      );
    } catch (error) {
      console.error(error, "<===err");
      setIsLoading(false);
    }
  };
  useEffect(() => {
    fetchData(filter);
    setcolumns(
      Columns({ handleEdithandler, handleViewUser,currentPage: filter?.pageNo, pageSize })
    );
  }, [filter]);
  const handleEdithandler = (info) => {
    setFormData({ ...formData, ...info });
    setDatasets(info);
    setEditModalShow(true);
  };

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };
  const handleEditSub = (info) => {
    console.log(info,"info==========,>")
    try {
      let data = {
        id: info.id,
        status: info.status,
      };
      const callback = (err, res) => {
        if (err) {
          console.log(err);
        } else {
          setEditModalShow(false);
          fetchData(filter);
          toast.success("User updated successfully!");
        }
      };
      console.log(data, "data");
      dispatch(
        SupportEdit({
          data: data,
          callback,
        })
      );
      console.log(data, "data");
    } catch (error) {
      console.error(error, "<===err");
    }
  };
  const handleViewUser = (row) => {
    navigate(`${row.id}`, { state: { row } });
  };

  const onClickFilter = (e) => {
    e?.preventDefault();
    setFilter({
      ...filter,
      pageNo: 1,
      limit: pageSize,
      search_text: search_text,
    });
  };

  const clearFilter = () => {
    setFilter((pre) => ({
      ...pre,
      pageNo: 1,
      search_text: "",
    }));
    setSearch_text("");
  };


  return (
    <>
      {isLoading && (
        <div className="main-loader">
          <FadeLoader size={1000} />
        </div>
      )}
      {editModalShow && (
        <EditSupport
          show={editModalShow}
          handleClose={() => {
            setEditModalShow(false);
          }}
          title={"Edit Support"}
          content={""}
          handleConfirm={handleEditSub}
          loading={loading}
          initialValues={formData}
        />
      )}
      <Helmet title={SUPPORT.CURRENT_MODULE} />
      <section className="section">
        <div className="section-header">
          <h1>{SUPPORT.CURRENT_MODULE}</h1>

          <div className="section-header-breadcrumb">
            <div className="breadcrumb-item active">
              <Link to={"/admin/" + Path.dashboard}>Dashboard</Link>
            </div>
            <div className="breadcrumb-item">{SUPPORT.CURRENT_MODULE} </div>
          </div>
        </div>
        <div className="section-body">
          <div className="card">
            <div className="row justify-content-between">
              <div className="col-6">
                <div className="card-header">
                  <h2 className="section-title">{SUPPORT.TOP_CONTENT}</h2>
                </div>
              </div>
              <div className="col-12">
                <form onSubmit={onClickFilter}>
                  <div className="card-header">
                    <div className="col-lg-4 col-sm-12 col-md-12 my-2 px-0">
                      <input
                        className="form-control"
                        name="search_text"
                        onChange={(e) => setSearch_text(e.target.value)}
                        value={search_text}
                        placeholder="Search using email..."
                      />
                    </div>
                  </div>
                  <div className="col-12 my-2 gap-4 ">
                    <div className="d-flex gap-4">
                      <button type="submit" className="btn btn-primary btn-lg">
                        Search
                      </button>
                      <button
                        onClick={() => clearFilter()}
                        type="button"
                        className="btn btn-primary btn-lg"
                      >
                        Clear Search
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
          {!isLoading && doctor?.users?.length && (
            <Table
              data={doctor?.users}
              columns={columns}
              setFilter={setFilter}
              handleTableChange={handlePageChange}
              totalCount={doctor?.total_record_count}
              filter={filter}
            />
          )}
          {!isLoading && !doctor && (
            <p style={{ textAlign: "center" }}>No Support Request Found</p>
          )}
        </div>
      </section>
    </>
  );
};

export default List;
